module.exports = __webpack_public_path__ + "img/camera_yellow.73977a38.svg";